import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ExitToApp } from '@mui/icons-material';
import { Button, Box, Typography } from '@mui/material';
import { userSelector } from '../../features/auth';
import { useGetListQuery } from '../../services.js/TMDB';
import RatedCards from '../RatedCards/RatedCards';

const Profile = () => {
  const { user } = useSelector(userSelector);
  const { data: watchListMovies, refetch: refetchWatchList } = useGetListQuery({ listName: 'watchlist/movies', accountId: user.id, sessionId: localStorage.getItem('session_id'), page: 1 });
  const { data: favoriteMovies } = useGetListQuery({ listName: 'favorite/movies', accountId: user.id, sessionId: localStorage.getItem('session_id'), page: 1 });

  useEffect(() => {
    refetchWatchList();
  }, []);
  const logout = () => {
    localStorage.clear();
    window.location.href = '/';
  };
  return (
    <Box>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h4" gutterBottom> My Profile</Typography>
        <Button color="inherit" onClick={logout}>
          Logout &nbsp; <ExitToApp />
        </Button>
      </Box>
      {!watchListMovies?.results?.length ? <Typography variant="h5">Add favorites or watchlist some movies to see them here !!</Typography>
        : (
          <Box>
            <RatedCards title="Watchlist" data={watchListMovies} />
          </Box>
        )}
    </Box>
  );
};

export default Profile;
